import Announcement from '../message/Announcement';
import Button from '../buttons/Button';
import Modal from 'react-modal';
import Upsell from './TopBarUpsell';
import { NavLink, useLocation } from 'react-router-dom';
import React, { useEffect, useState } from 'react';
import TeamMessage from '../message/TeamMessage';
import TeamModal from '../team/TeamModal';
import TeamSelector from '../team/TeamSelector';
import PrimaryButton from 'shared/buttons/PrimaryButton';
import { useDispatch, useSelector } from 'react-redux';
import { cloneDeep } from 'lodash';
import { checkPermission, onLoggedIn, setDivision, setTeam } from 'utils/ProfileHelpers';
import { setAction } from 'redux/actions/profile';
import { showSignupModalAction } from 'redux/actions/projectConfig';
import HamburgerMenu from './HamburgerMenu';

export default (props) => {
  const dispatch = useDispatch();
  const location = useLocation();
  const profile = useSelector((state) => state.profile);
  const { showChartWizard } = useSelector((state) => state.chartEditorPage);
  const { paths } = useSelector((state) => state.app);
  const { unreadMessages, user, teams, announcements, messages, team, divisions, division } = profile;
  const { toggleMenu, navOpen, showDivisionModal, announcementsRead } = props;
  const [showLogoutModal, setShowLogoutModal] = useState(false);
  const [showNewTeamModal, setShowNewTeamModal] = useState(false);
  const [showTeamMessagesModal, setShowTeamMessagesModal] = useState(false);
  const [showAnnouncementsModal, setShowAnnouncementsModal] = useState(
    announcements?.new?.length > 0 && !announcementsRead
  );

  const setTeamFromDropdown = (team) => setTeam(team);
  const checkTeamPermission = (permission) => checkPermission(permission, profile);

  const editorPaths = ['/create', '(.edit.)([-0-9]+)', '(.edittheme.)([-0-9]+)', '/createtheme'];

  useEffect(() => {
    setShowAnnouncementsModal(announcements?.new?.length > 0 && !props.announcementsRead);
  }, [announcements]);

  const openLogoutModal = () => setShowLogoutModal(true);
  const closeLogoutModal = () => setShowLogoutModal(false);
  const openNewTeamModal = () => setShowNewTeamModal(true);
  const closeNewTeamModal = () => setShowNewTeamModal(false);
  const closeTeamMessagesModal = () => setShowTeamMessagesModal(false);
  const showNotifications = () => setShowAnnouncementsModal(true);
  const showSignupModal = () => dispatch(showSignupModalAction());

  const logout = () => {
    props.logout();
    closeLogoutModal();
  };

  const closeAnnouncementsModal = () => {
    setShowAnnouncementsModal(false);
    props.setAnnouncementsAsRead();
  };

  const checkPath = (path) => {
    let found = false;
    editorPaths.forEach(function (e) {
      if (path.match(e)) found = true;
    });
    return found;
  };

  const setAsRead = (message) => {
    let stateMessages = cloneDeep(unreadMessages);

    stateMessages.forEach((m) => {
      if (m.id === message.id) {
        m.read = 1;
      }
    });

    dispatch(
      setAction({
        unreadMessages: stateMessages
      })
    );
  };

  const navActions = props.navActions[location.pathname];
  const inEditor = checkPath(location.pathname);

  const parentSelector = () => document.querySelector('.page-container');

  return (
    <div className={'navbar navbar-default ' + (!team ? ' not-logged-in' : '') + (inEditor ? ' editor' : '')}>
      <Modal
        className="hc-modal-content"
        overlayClassName="hc-modal-overlay"
        appElement={document.querySelector('.page-container')}
        parentSelector={parentSelector}
        onRequestClose={closeLogoutModal}
        isOpen={showLogoutModal}
        contentLabel="Logout"
      >
        <p>Are you sure you want to sign out?</p>
        <Button buttonText="Yes" buttonClass="bulk-action-btn btn-primary" onClick={logout} />{' '}
        <Button buttonText="Cancel" buttonClass="bulk-action-btn grey" onClick={closeLogoutModal} />
      </Modal>
      <TeamModal
        isOpen={showNewTeamModal}
        parentSelector={parentSelector}
        close={closeNewTeamModal}
        reloadTeams={onLoggedIn}
      />

      <Modal
        className="hc-modal-team-message-content"
        overlayClassName="hc-modal-overlay"
        appElement={document.querySelector('.page-container')}
        parentSelector={parentSelector}
        onRequestClose={closeTeamMessagesModal}
        isOpen={showTeamMessagesModal}
        contentLabel="Messages"
      >
        <TeamMessage
          messages={[...(unreadMessages ?? []), ...(messages ?? [])]}
          team={team}
          close={closeTeamMessagesModal}
          setAsRead={setAsRead}
        />
      </Modal>

      <Modal
        className="hc-modal-team-message-content"
        overlayClassName="hc-modal-overlay"
        parentSelector={parentSelector}
        onRequestClose={closeAnnouncementsModal}
        isOpen={showAnnouncementsModal}
        contentLabel="Announcement"
      >
        <Announcement announcements={announcements} close={closeAnnouncementsModal} />
      </Modal>

      <HamburgerMenu team={team} toggleMenu={toggleMenu} navOpen={navOpen} paths={paths} inEditor={inEditor} />

      <div className={'navbar-collapse'}>
        <div className="navbar-inner flex">
          <div className="info-container content-center">
            {!inEditor && (
              <div className="team-selector-list hidden ev-sm:block">
                {teams && team && (
                  <TeamSelector
                    key={divisions}
                    team={team}
                    setTeam={setTeamFromDropdown}
                    showModal={showDivisionModal}
                    division={division}
                    divisions={divisions}
                    setDivision={setDivision}
                    checkPermission={checkTeamPermission}
                  >
                    {teams}
                  </TeamSelector>
                )}
              </div>
            )}
          </div>

          <div className="flex ml-auto mr-4 content-center">
            {!inEditor && (
              <div className="create-chart-list mr-4">
                {(!navActions || navActions.length < 1) && checkTeamPermission('create_chart') && (
                  <div>
                    <NavLink to={paths.vizPicker} className="bulk-action-btn ev-red everviz-red">
                      <i className="fa fa-plus" aria-hidden="true" />
                      &nbsp;New project
                    </NavLink>
                  </div>
                )}
              </div>
            )}
            {team?.charts_max && <Upsell />}
          </div>

          <ul className="nav navbar-nav navbar-right">
            {navActions &&
              navActions.map((action, index) => (
                <li key={index} className="li-btn group">
                  <a
                    onClick={action.onClick}
                    className={
                      'btn' +
                      (action.className ? ' ' + action.className : '') +
                      (action.tooltip ? ' highed-template-tooltip' : '')
                    }
                  >
                    <span>
                      {action.icon && (
                        <i className={'text-ev-navy-blue-2 group-hover:text-white fa fa-' + action.icon} />
                      )}
                      {(action.icon ? ' ' : '') + action.text}
                    </span>
                    {action.tooltip && <span className="highed-tooltip-text">{action.tooltip.text}</span>}
                  </a>
                </li>
              ))}

            {!inEditor && user && (
              <li className="group li-btn hidden-sm">
                <a className="btn highed-template-tooltip" onClick={showNotifications}>
                  <span>
                    <i className="text-ev-navy-blue-2 group-hover:text-white fa fa-bell no-margin" />
                    {announcements &&
                      ((announcements.new && announcements.new.length > 0) ||
                        (announcements.old && announcements.old.length > 0)) && <div className="notification-circle" />}
                  </span>
                  <span className="highed-tooltip-text">Notifications</span>
                </a>
              </li>
            )}

            {user && teams.length === 0 && (
              <li className="li-btn">
                <a className="create-chart-btn btn" onClick={openNewTeamModal}>
                  {' '}
                  CREATE TEAM{' '}
                </a>
              </li>
            )}

            {user && (
              <li className="group li-btn">
                <a className="btn highed-template-tooltip" onClick={openLogoutModal}>
                  <span>
                    <i className="text-ev-navy-blue-2 group-hover:text-white fa fa-sign-out-alt" />
                  </span>
                  <span className="highed-tooltip-text">Sign out</span>
                </a>
              </li>
            )}
            {!user && (
              <li>
                {showChartWizard ? (
                  <PrimaryButton text="Sign in" onClick={showSignupModal} className="m-4 min-w-[115px]" />
                ) : (
                  <NavLink
                    className="bulk-action-btn sign-in-btn everviz-red m-4"
                    to={{
                      pathname: paths.login,
                      state: {
                        overrideRedirect: location.pathname === '/',
                        from: location.pathname
                      }
                    }}
                  >
                    Sign in
                  </NavLink>
                )}
              </li>
            )}
          </ul>
        </div>
      </div>
    </div>
  );
};
